import { render } from "./updateContactCobre.vue?vue&type=template&id=5ed392f7&scoped=true"
import script from "./updateContactCobre.vue?vue&type=script&lang=js"
export * from "./updateContactCobre.vue?vue&type=script&lang=js"

import "./updateContactCobre.vue?vue&type=style&index=0&id=5ed392f7&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ed392f7"]])

export default __exports__